import React, { useState } from "react";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import InfoDialog from "../components/InfoDialog";

const LayerInfo = ({
  shortDescription,
  longDescription,
  longDescriptionTitle,
}) => {
  const [longDescriptionOpen, setLongDescriptionOpen] = useState(false);
  if (!shortDescription) return null;

  const tooltipTitle = longDescription
    ? `${shortDescription} Click here to read more.`
    : shortDescription;

  return (
    <>
      <Tooltip placement="top" title={
        <Box sx={{ fontSize: "0.8rem" }}>
          {tooltipTitle}
        </Box>
      }>
        {longDescription ? (
          <IconButton onClick={() => setLongDescriptionOpen(true)}>
            <InfoIcon fontSize="small"></InfoIcon>
          </IconButton>
        ) : (
          <InfoIcon fontSize="small" sx={{ pl: 1 }}></InfoIcon>
        )}
      </Tooltip>
      <InfoDialog
        open={longDescriptionOpen}
        setOpen={setLongDescriptionOpen}
        dialogTitle={longDescriptionTitle}
        dialogBody={longDescription}
      />
    </>
  );
};

export default LayerInfo;
